import { lazy } from '@loadable/component';
import { useFlag } from '@simplywallst/unleash';

const LazyAdPlan = lazy(() =>
  import('./AdPlan').then((module) => ({ default: module.AdPlan }))
);
const LazyOfferwall = lazy(() =>
  import('./Offerwall').then((module) => ({
    default: module.Offerwall,
  }))
);

export const AdPlanLoader = () => {
  const flag = useFlag('ad-supported-free-plan');

  if (flag.variant?.name !== 'variant') {
    return null;
  }

  return (
    <>
      <LazyAdPlan />
      <LazyOfferwall />
    </>
  );
};
